import { buildAppStatusState, type AppStatusPayload } from '../lib/app-status';
import { useAppStatus } from './useAppStatus';

interface SeasonYearsState {
  currentSeasonYear: number;
  activeSeasonYear: number;
  resolved: boolean;
  seasonOptions: number[];
}
export function buildSeasonYearsState(status: AppStatusPayload | null, fallbackYear?: number): SeasonYearsState {
  const years = buildAppStatusState(status, fallbackYear);

  return {
    currentSeasonYear: years.currentSeasonYear,
    activeSeasonYear: years.activeSeasonYear,
    resolved: years.resolved,
    seasonOptions: years.seasonOptions,
  };
}

export function useSeasonYears(): SeasonYearsState {
  const years = useAppStatus();
  return years;
}
